export const bundleChannelSubscription = 'admin-bundles';
export const orderChannelSubscription = 'admin-orders';
export const bundleEventName = 'bundle-updated';
export const orderUpdateEvent = 'order-updated';
export const orderCreateEvent = 'order-created';
export const orderCancelEvent = 'order-canceled';
